/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AvailableSiteView } from './availableSiteView';
import { SiteResultView } from './siteResultView';

export interface SitePermissionSessionView { 
    id?: string;
    purpose?: SitePermissionSessionView.PurposeEnum;
    status?: SitePermissionSessionView.StatusEnum;
    errorMessage?: string;
    expiresAt?: Date;
    availableSites?: Array<AvailableSiteView>;
    results?: Array<SiteResultView>;
}
export namespace SitePermissionSessionView {
    export type PurposeEnum = 'MANAGE_SITES' | 'DISCONNECT';
    export const PurposeEnum = {
        MANAGESITES: 'MANAGE_SITES' as PurposeEnum,
        DISCONNECT: 'DISCONNECT' as PurposeEnum
    };
    export type StatusEnum = 'AWAITING_LOGIN' | 'AWAITING_SELECTION' | 'AWAITING_APPLY_LOGIN' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';
    export const StatusEnum = {
        AWAITINGLOGIN: 'AWAITING_LOGIN' as StatusEnum,
        AWAITINGSELECTION: 'AWAITING_SELECTION' as StatusEnum,
        AWAITINGAPPLYLOGIN: 'AWAITING_APPLY_LOGIN' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        COMPLETEDWITHERRORS: 'COMPLETED_WITH_ERRORS' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    };
}